import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './modules/auth.module.js'
import AssetsMapModule from './modules/assetsMap.module'
import OrderStateModule from './modules/orderState.module'
// import OrganizationModule from './modules/organization.module'
import _ from 'lodash/lodash'
Vue.use(Vuex)

const store = new Vuex.Store({
  
  modules: {
    Auth: AuthModule,
    AssetsMap: AssetsMapModule,
    OrderState: OrderStateModule,
    // Organization: OrganizationModule
  },

  state: {
    environment: process.env.ENVIRONMENT || 'production',
    initialReferrer: document.referrer || '',
    ajaxLoadingInProgress: 0,
    routeLoadingInProgress: 0,
    headerHeight: 0,
    idleHeight: 0,
    orderTableParams: {
      order_by: 'id',
      sort_by: 'desc'
    },
    guideSidebar: false,
    apiErrorsVisible: true,
  },

  mutations: {
    // This mutation should only be triggered by dispatching an appropriate action
    // (deliberately uses a delayed function when disabling the loader)
    _AJAX_LOADING (state, start) {
      if (start) {
        state.ajaxLoadingInProgress++
      } else {
        if (state.ajaxLoadingInProgress > 0) {
          state.ajaxLoadingInProgress = state.ajaxLoadingInProgress - 1
        }
      }
    },

    // This mutation should only be triggered by dispatching an appropriate action
    // (deliberately uses a delayed function when disabling the loader)
    _ROUTE_LOADING (state, start) {
      if (start) {
        state.routeLoadingInProgress++
      } else {
        if (state.routeLoadingInProgress > 0) {
          state.routeLoadingInProgress = state.routeLoadingInProgress - 1
        }
      }
    },

    _SET_ORDER_TABLE_PARAMS (state, data) {
      state.orderTableParams = data
    },
    _SET_IDLE_HEIGHT (state, data) {
      state.idleHeight = data
    }
  },

  actions: {
    ajaxLoading ({ commit }, start) {
      start = typeof start !== 'boolean' ? true : start

      if (start) {
        commit('_AJAX_LOADING', true)
      } else {
        _.delay(() => {
          commit('_AJAX_LOADING', false)
        }, 50)
      }
    },

    routeLoading ({ commit }, start) {
      start = typeof start !== 'boolean' ? true : start

      if (start) {
        commit('_ROUTE_LOADING', true)
      } else {
        _.delay(() => {
          commit('_ROUTE_LOADING', false)
        }, 50)
      }
    }
  },

  getters: {
    ajaxIsLoading: state => {
      return state.ajaxLoadingInProgress > 0
    },

    routeIsLoading: state => {
      return state.routeLoadingInProgress > 0
    },

    insideMobileApp: state => {
      // @todo - improve the cordova application detection logic
      // (just in a hurry to restore behaviour that was lost)
      if (state.initialReferrer) {
        if (typeof URL === 'function') {
          const referrerUrl = new URL(state.initialReferrer);
          const workOrderAppUrl = new URL(process.env.APP_WORK_ORDERS_URL);
          return referrerUrl.host == workOrderAppUrl.host;
        }
        else {
          // Unsure if js URL constructor works on old test iPad Mini
          // so am trying a fallback "a" DOM node parsing technique.
          // Method adapted: https://stackoverflow.com/a/15979390
          let ordersUrl = document.createElement('a');
          let referrerUrl = document.createElement('a');
          ordersUrl.href = process.env.APP_WORK_ORDERS_URL;
          referrerUrl.href = state.initialReferrer;
          return referrer.host == ordersUrl.host;
        }
      }
      return false;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js